import { FilterOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import { isValidArray } from '../../../../../utils/helpers'
import styles from '../../../../../testrun.module.css'

const FILTER_STYLES = {
    epic: { bg: '#dbeafe', color: '#1d4ed8' },
    sprint: { bg: '#e0e7ff', color: '#4338ca' },
    tags: { bg: '#dcfce7', color: '#15803d' },
    status: { bg: '#fef3c7', color: '#b45309' },
    search: { bg: '#e0e7ff', color: '#4338ca' },
}

function FilterChip({ label, value, filterKey, onRemove }) {
    const palette = FILTER_STYLES[filterKey] || { bg: '#f1f5f9', color: '#475569' }
    return (
        <Tag
            className={styles.filterTag}
            closable={!!onRemove}
            onClose={(e) => {
                e.preventDefault()
                onRemove?.(filterKey)
            }}
            style={{ background: palette.bg, color: palette.color }}
        >
            <span className={styles.filterTagLabel}>{label}:</span>{' '}
            <span className={styles.filterTagValue}>{value}</span>
        </Tag>
    )
}

export const AppliedFilter = ({
    data,
    onClearAll,
    onRemove,
    searchValue = '',
}) => {
    const count =
        (data?.epic?.length ? 1 : 0) +
        (data?.sprint ? 1 : 0) +
        (data?.tags?.length ? 1 : 0) +
        (data?.status ? 1 : 0) +
        (searchValue?.length ? 1 : 0)

    if (!count) return null

    return (
        <div className={styles.appliedFilterBar}>
            <FilterOutlined style={{ color: '#6366f1' }} />
            <span className={styles.appliedFilterLabel}>
                {count} filter{count === 1 ? '' : 's'} applied
            </span>

            {isValidArray(data?.epic) && (
                <FilterChip
                    filterKey="epic"
                    label="Epic"
                    value={data.epic.map((t) => t.label).join(', ') || 'N/A'}
                    onRemove={onRemove}
                />
            )}

            {data?.sprint && (
                <FilterChip
                    filterKey="sprint"
                    label="Sprint"
                    value={data.sprint?.label || 'N/A'}
                    onRemove={onRemove}
                />
            )}

            {!!data?.tags?.length && (
                <FilterChip
                    filterKey="tags"
                    label="Tags"
                    value={data.tags.map((t) => t.label).join(', ') || 'N/A'}
                    onRemove={onRemove}
                />
            )}

            {data?.status && (
                <FilterChip
                    filterKey="status"
                    label="Status"
                    value={data.status?.label || data.status || 'N/A'}
                    onRemove={onRemove}
                />
            )}

            {searchValue && (
                <FilterChip
                    filterKey="search"
                    label="Search"
                    value={searchValue}
                    onRemove={onRemove}
                />
            )}

            <CloseCircleOutlined
                onClick={onClearAll}
                title="Clear all filters"
                style={{ color: '#ef4444', cursor: 'pointer', marginLeft: 4 }}
            />
        </div>
    )
}
